import linkedInLogo from "../asset/LinkedIn.png";
import email from "../asset/Email.png";
import { Box, IconButton, Tooltip } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useEffect, useState } from "react";

export const NavBar = () => {
  return (
    <Box
      sx={{
        padding: 3,
        paddingLeft: { xs: 2, md: 4 },
        paddingRight: { xs: 2, md: 4 },
        justifyContent: "flex-end",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <IconButton
        href="https://www.linkedin.com/in/ideavanicha/"
        target="_blank"
      >
        <LinkedInIcon sx={{ color: "#0366C8" }} />
      </IconButton>
      <Tooltip title="ideavanicha@gmail.com">
        <IconButton>
          <EmailIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
